import { useRouterHistory } from 'react-router';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import QS from 'qs';

const createAppHistory = useRouterHistory(createBrowserHistory);

const history = createAppHistory({
  parseQueryString: QS.parse.bind(QS),
  stringifyQuery: QS.stringify.bind(QS)
});

export default history;



// WEBPACK FOOTER //
// ./app/app-history.js